import CollectionUtil from "../../../util/CollectionUtil"
import { EvaluateResultDto, WorkspaceEvaluationDeltaDto, WorkspaceEvaluationDto } from "../model/dto"

/**
 * Pure delta operations over workspace-evaluation results.
 *
 * `merge` folds a delta into the current evaluation (upsert `changed` by (type, id), remove
 * `deleted`, replace metadata). `hash` computes the order-independent 32-bit signed digest the
 * server also computes, so a merged result set can be checked for divergence bit-for-bit.
 */
export const WorkspaceEvaluations = {
  merge(evaluation: WorkspaceEvaluationDto, delta: WorkspaceEvaluationDeltaDto): WorkspaceEvaluationDto {
    const results = CollectionUtil.associateBy(evaluation.results, (it) => resultKey(it.type, it.id))

    delta.changed.forEach((it) => results.set(resultKey(it.type, it.id), it))
    delta.deleted.forEach((it) => results.delete(resultKey(it.type, it.id)))

    return {
      workspace: delta.workspace,
      results: Array.from(results.values()),
      metadata: delta.metadata
    }
  },

  hash(results: EvaluateResultDto[]): number {
    return results
      .map((it) => it.hash)
      .sort((a, b) => a - b)
      .reduce((acc, h) => (Math.imul(acc, 31) + h) | 0, 1)
  }
}

function resultKey(type: string, id: number): string {
  return `${type}:${id}`
}
